import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  onClick,
  type = 'button',
  className = ''
}) => {
  const baseStyles = 'font-medium transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark hover:shadow-lg hover:shadow-primary/20',
    secondary: 'bg-secondary text-white hover:bg-secondary-dark hover:shadow-lg hover:shadow-secondary/20',
    outline: 'border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-white'
  };
  
  const sizes = {
    sm: 'h-11 px-6 text-sm rounded-xl',
    md: 'h-14 px-12 text-base rounded-2xl',
    lg: 'h-16 px-12 text-lg rounded-2xl'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
    >
      {children}
    </button>
  );
};